import apiService from "./apiService"
import { OfferModel } from "../models/OfferModel";
import { OfferItemModel } from "../models/OfferItemModel";

const offerService = {
    searchOffers: async (offset: number, count: number, keyword: string, state:string ='') => {
        const response: { offers: any[], offerCount: number } = await apiService.get(`/Offer?offset=${offset}&count=${count}&keyword=${keyword}&state=${state}`);
        response.offers = response.offers.map((x) => new OfferModel(x));
        return response;
    },
    updateOffer: async (offerId: number, qty: number, discount: number, status: string) => {
        const response = await apiService.put(`/Offer/${offerId}`, { quantity: qty, discount: discount, state: status });
        return response;
    },
    getOffer: async (offerId: number) => {
        const response: any = await apiService.get(`/Offer/${offerId}`);
        return new OfferModel(response);
    },
    getOfferItem: async (offerItemId: number) => {
        const response: any = await apiService.get(`/Offer/Item/${offerItemId}`);
        return new OfferItemModel(response);
    },
    updateOfferTermsAccepted: async (offerId: number) => {
        const response = await apiService.put(`/Offer/${offerId}/CommissionTermsAccepted`, {});
        return response;
    }

}

export default offerService;